import styled, { keyframes } from "styled-components";

const HEIGHT = "var(--headerHeight)";

const slideInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Wrapper = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: ${HEIGHT};
    background: linear-gradient(180deg, rgba(10, 10, 10, 0.95) 0%, rgba(10, 10, 10, 0.92) 100%);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border-bottom: 1px solid rgba(212, 175, 55, 0.1);
    z-index: 100;
    animation: ${slideInDown} 0.6s ease-out;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: var(--maxWidth);
    height: 100%;
    margin: 0 auto;
    padding: 0 4%;
    gap: 12px;

    @media (max-width: 768px) {
        padding: 0 16px;
    }
`;

export const Logo = styled.a`
    height: 48px;
    flex-shrink: 0;
    transition: transform 0.3s ease;

    img {
        height: 100%;
        width: auto;
        object-fit: contain;
        display: block;
    }

    &:hover {
        transform: scale(1.05);
    }

    @media (max-width: 768px) {
        height: 40px;
    }
`;

export const NavLinks = styled.nav`
    display: flex;
    gap: 32px;
    align-items: center;
    flex: 1;
    justify-content: center;

    @media (max-width: 1024px) {
        gap: 24px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const NavLink = styled.a`
    font-size: 0.95rem;
    font-weight: 500;
    color: var(--lightText);
    opacity: 0.8;
    transition: all 0.3s ease;
    white-space: nowrap;
    position: relative;
    letter-spacing: 0.3px;

    &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 50%;
        width: 0;
        height: 2px;
        background: linear-gradient(90deg, transparent, var(--accentGold), transparent);
        transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    }

    &:hover {
        opacity: 1;

        &::after {
            width: 100%;
            left: 0;
        }
    }
`;

export const ContactButton = styled.a`
    padding: 10px 24px;
    background: var(--accentGold);
    border: 2px solid var(--accentGold);
    color: var(--darkBG);
    border-radius: 6px;
    font-weight: 700;
    font-size: 0.9rem;
    white-space: nowrap;
    transition: all 0.3s ease;
    flex-shrink: 0;
    letter-spacing: 0.5px;
    position: relative;

    &:hover {
        background: transparent;
        color: var(--accentGold);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(212, 175, 55, 0.2);
    }

    &:active {
        transform: translateY(0);
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const MenuButton = styled.button`
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    width: 44px;
    height: 44px;
    padding: 10px;
    background: transparent;
    border: 1px solid var(--cardBorder);
    border-radius: 8px;
    cursor: pointer;
    flex-shrink: 0;

    span {
        display: block;
        width: 100%;
        height: 2px;
        background: var(--lightText);
        border-radius: 2px;
        transition: transform 0.3s ease, opacity 0.3s ease;
    }

    @media (max-width: 768px) {
        display: flex;
    }
`;

export const MobileNav = styled.nav`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        position: fixed;
        top: ${HEIGHT};
        left: 0;
        width: 100vw;
        height: calc(100vh - ${HEIGHT});
        padding: 24px 20px 32px;
        gap: 8px;
        background: rgba(8, 8, 8, 0.98);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        z-index: 99;
        overflow-y: auto;
        transform: translateX(${({ $open }) => ($open ? "0" : "100%")});
        opacity: ${({ $open }) => ($open ? 1 : 0)};
        visibility: ${({ $open }) => ($open ? "visible" : "hidden")};
        transition: transform 0.3s ease, opacity 0.3s ease, visibility 0.3s;
    }
`;

export const MobileNavLink = styled.a`
    display: block;
    width: 100%;
    padding: 16px 12px;
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--lightText);
    border-bottom: 1px solid var(--cardBorder);
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;

    &:hover,
    &:active {
        color: var(--accentGold);
    }
`;

export const MobileContactButton = styled.a`
    margin-top: 16px;
    padding: 14px 24px;
    text-align: center;
    background: var(--accentGold);
    color: var(--darkBG);
    font-weight: 700;
    border-radius: 10px;
    font-size: 1rem;
`;
